import { useRouteQuery } from '@/hooks'
import dayjs from 'dayjs'
import { Typography } from '@mui/material'

interface AttendanceEmployeeTotalProps {
  dataEmployee: any
}

export const AttendanceEmployeeTotal = ({ dataEmployee }: AttendanceEmployeeTotalProps) => {
  const { __, __n } = useTranslator()
  const { searchQuery } = useRouteQuery()

  const currentMonthDisplay = useMemo(() => {
    const monthParam = searchQuery.get('month')

    if (monthParam) {
      return dayjs(monthParam).format('MMMM YYYY')
    }

    return dayjs().format('MMMM YYYY')
  }, [searchQuery.get('month')])

  return (
    <div className='p-5'>
      <div className='flex items-center gap-2 justify-between border-b border-[#2f2b3d1f] pb-2'>
        <div className='text-[18px] font-medium text-[#2f2b3d]'>
          {__('Attendance')} {currentMonthDisplay}
        </div>
        <div className='flex items-center gap-3'>
          <div className='flex items-center gap-1'>
            <div className='w-[16px] h-[16px] rounded-full bg-[#577dfd]'></div>
            <Typography variant='body2' className='text-[14px] font-normal text-[#2f2b3de6]'>
              {__('Worked Day')}
            </Typography>
          </div>
          <div className='flex items-center gap-1'>
            <div className='w-[16px] h-[16px] rounded-full bg-[#ff7074]'></div>
            <Typography variant='body2' className='text-[14px] font-normal text-[#2f2b3de6]'>
              {__('Absent Day')}
            </Typography>
          </div>
          <div className='flex items-center gap-1'>
            <div className='w-[16px] h-[16px] rounded-full bg-[#c0bec5]'></div>
            <Typography variant='body2' className='text-[14px] font-normal text-[#2f2b3de6]'>
              {__('Non-Working Day')}
            </Typography>
          </div>
        </div>
      </div>

      <div className='grid grid-cols-4 gap-x-3 gap-y-5 mt-3'>
        <div className='flex items-start gap-2'>
          <div>
            <img src='/images/icons/workday.png' alt='avatar' className='w-[40px] h-[40px]' />
          </div>
          <div>
            <div className='text-[18px] font-medium text-[#2f2b3de6]'>{__n(dataEmployee?.data?.data?.working_day)}</div>
            <div className='text-[13px] font-normal text-[#2f2b3db3]'>{__('Workday This Month')}</div>
          </div>
        </div>
        <div className='flex items-start gap-2'>
          <div>
            <img src='/images/icons/worked.png' alt='avatar' className='w-[40px] h-[40px]' />
          </div>
          <div>
            <div className='text-[18px] font-medium text-[#2f2b3de6]'>
              {__n(dataEmployee?.data?.data?.attendance_status?.worked_day)}
            </div>
            <div className='text-[13px] font-normal text-[#2f2b3db3]'>{__('Worked Day This Month')}</div>
          </div>
        </div>
        <div className='flex items-start gap-2'>
          <div>
            <img src='/images/icons/absent.png' alt='avatar' className='w-[40px] h-[40px]' />
          </div>
          <div>
            <div className='text-[18px] font-medium text-[#2f2b3de6]'>
              {__n(dataEmployee?.data?.data?.attendance_status?.absent)}
            </div>
            <div className='text-[13px] font-normal text-[#2f2b3db3]'>{__('Absent Day This Month')}</div>
          </div>
        </div>
        <div className='flex items-start gap-2'>
          <div>
            <img src='/images/icons/none_workday.png' alt='avatar' className='w-[40px] h-[40px]' />
          </div>
          <div>
            <div className='text-[18px] font-medium text-[#2f2b3de6]'>
              {__n(dataEmployee?.data?.data?.attendance_status?.non_working_day)}
            </div>
            <div className='text-[13px] font-normal text-[#2f2b3db3]'>{__('Non-workday This Month')}</div>
          </div>
        </div>
      </div>
    </div>
  )
}
